export const FETCH_DAY_EVENTS: string = 'FETCH_DAY_EVENTS'
export const FETCH_CALENDAR_EVENTS: string = 'FETCH_CALENDAR_EVENTS'
export const FETCH_SETTINGS_DATA: string = 'FETCH_SETTINGS_DATA'
export const FETCH_PLAYBOOK_DATA: string = 'FETCH_PLAYBOOK_DATA'
export const FETCH_USER: string = 'FETCH_USER'
export const GET_APP_DATA: string = 'GET_APP_DATA'
export const ADD_EVENT: string = 'ADD_EVENT'
export const CHANGE_STATE: string = 'CHANGE_STATE'
